import { createSlice } from "@reduxjs/toolkit";

export const lockerUserAccountsSlice = createSlice({
	name: "lockerUserAccounts",
	initialState: {
		searchCriteria: {
			operatorId: localStorage.getItem("user")
				? JSON.parse(localStorage.getItem("user")).operator_id
				: "",
			lastName: "",
			firstName: "",
			userMobile: "",
			gender: [],
			ageFrom: 20,
			ageTo: 30,
			verifiedStatus: "-2",
			withApp: "-2",
			// firstName: "",
			signupDateFrom: new Date("2024-01-01T00:00:00Z"),
			signupDateInto: new Date(),
		},
		lockerUserAccountsList: [],
	},
	reducers: {
		setSearchCriteria: (state, actions) => {
			const tempVar = { ...state.searchCriteria };
			const { name, value } = actions.payload;
			tempVar[name] = value;
			state.searchCriteria = tempVar;
		},
		getLockerUserAccountsList: (state, actions) => {
			state.lockerUserAccountsList = actions.payload;
		},
		handleChangeReducer: (state, actions) => {
			const { name, value } = actions.payload;
			console.log(`Updating ${name} with value: ${value}`);
			state.searchCriteria[name] = value;
		},
		resetSearchCriteria: (state) => {
			state.searchCriteria = {
				operatorId: localStorage.getItem("user")
					? JSON.parse(localStorage.getItem("user")).operator_id
					: "",
				lastName: "",
				firstName: "",
				userMobile: "",
				verifiedStatus: "-2",
				withApp: "-2",
				signupDateFrom: new Date("2024-01-01T00:00:00Z"),
				signupDateInto: new Date(),
				ageFrom: "",
				ageTo: "",
				gender: [],
			};
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	setSearchCriteria,
	getLockerUserAccountsList,
	handleChangeReducer,
	resetSearchCriteria,
} = lockerUserAccountsSlice.actions;

export default lockerUserAccountsSlice.reducer;
